import './errorBoundary.scss';

import Button from '@mui/material/Button';
import uniqueId from 'lodash/uniqueId';
import { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import ErrorImg from '../../assets/hero-error-with-smoke.svg';

const ErrorBoundaryFallback = (): ReactNode => {
  const { t } = useTranslation();

  const redirectToDashboard = (): void => {
    window.location.assign('/dashboard/garage');
  };

  return (
    <div className="error-container">
      <div className="error-img">
        <img alt={t('imageAlts.heroErrorWithSmoke')} src={ErrorImg} />
      </div>

      <div className="error-text">
        <h1>{t('errorBoundary.title')}</h1>
        <h2>
          <Trans
            components={[<br key={uniqueId('br-')} />]}
            i18nKey={'errorBoundary.subtitle'}
          />
        </h2>
      </div>

      <div>
        <Button type="button" variant="contained" onClick={redirectToDashboard}>
          {t('errorBoundary.dashboard')}
        </Button>
      </div>
    </div>
  );
};

export default ErrorBoundaryFallback;
